import { useContext } from 'react';

import { ProductCardContext } from './index';

export function useProductCard() {
  return useContext(ProductCardContext);
}
